import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

/**
 * Default language code used when no locale is available.
 * @constant {string}
 */
const DEFAULT_LANGUAGE = 'en'

/**
 * Default country code used when no locale is available.
 * @constant {string}
 */
const DEFAULT_COUNTRY = 'en'

/**
 * A custom hook to retrieve the language part of the locale.
 *
 * This hook uses the `useMultiSite` hook to access the current locale and extracts
 * the language code (e.g., 'en' from 'en-US'). If the locale is not available, it
 * defaults to the `DEFAULT_LANGUAGE`.
 *
 * @returns {string} The language code from the locale or the default language.
 */
export const useLocaleLanguage = () => {
    const {locale} = useMultiSite()
    return locale.id.split('-')?.[0] || DEFAULT_LANGUAGE
}

/**
 * A custom hook to retrieve the country part of the locale.
 *
 * This hook uses the `useMultiSite` hook to access the current locale and extracts
 * the country code (e.g., 'US' from 'en-US'). If the locale is not available, it
 * defaults to the `DEFAULT_COUNTRY`.
 *
 * @returns {string} The country code from the locale or the default country.
 */
export const useLocaleCountry = () => {
    const {locale} = useMultiSite()
    return locale.id.split('-')?.[1] || DEFAULT_COUNTRY
}
